exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1, h2, h3, h4 {\n  text-align: center;\n}\n\nh6 {\n  text-align: center;\n}\n\n#mapbox {\n  height: 100%;\n  width: 70%;\n}\n\n#sidebar {\n  float: left;\n  height: 100%;\n  width:30%;\n  background-color: white;\n  overflow: hidden;\n}\n\n#underbar {\nheight: 50%;\ncolor: black;\n}\n\n.star {\n  background-color:#F2BD42;\n  color: white;\n  text-align: center;\n  display: block;\n  margin: 0 auto;\n}\n\n#yoogle {\n  overflow: hidden;\n  width: 100%;\n}\n\n#google {\n  width: 100px;\n  display: block;\n  margin: 0 auto;\n}\n\n#image {\n    width: 200px;\n    height: 200px;\n    display: block;\n    margin: 0 auto;\n    border-radius: 50%\n}\n\n#scroll {\n  overflow-y: scroll;\n  height: 100%;\n}\n\n#read {\n  border: none;\n  text-align: center;\n  color: black;\n}\n\n.ui.search {\n  width: 200px;\n  display: block;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.business {\n  text-align: center;\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kaitlynfujihara/Desktop/keiken/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = main